export default function WhatIs() {
  return (
    <section id="guide" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-8">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            Getting Started
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
            What Is Kakobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[640px] mx-auto">
            A <strong>Kakobuy Spreadsheet</strong> is an organized collection of product discoveries, shopping recommendations, and useful buying information. Instead of searching thousands of products manually, users can explore carefully categorized lists and find popular items faster.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
            <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-3">
              <i className="ri-file-list-3-line"></i>
            </div>
            <h3 className="font-semibold text-foreground-900 text-sm mb-1.5">Organized Product Collections</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              Products are sorted into intuitive categories like shoes, clothing, accessories, and electronics. Each entry includes key information to help you evaluate items at a glance without endless scrolling.
            </p>
          </div>
          <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
            <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-3">
              <i className="ri-community-line"></i>
            </div>
            <h3 className="font-semibold text-foreground-900 text-sm mb-1.5">Community-Driven Discoveries</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              The best finds come from real shoppers sharing their experiences. Our spreadsheets aggregate community recommendations, popular picks, and hidden gems that you might otherwise miss.
            </p>
          </div>
          <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
            <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-3">
              <i className="ri-refresh-line"></i>
            </div>
            <h3 className="font-semibold text-foreground-900 text-sm mb-1.5">Regularly Updated Content</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              Shopping trends change fast. Our spreadsheets are refreshed with new product finds, seasonal collections, and trending items so you always have access to what is popular right now.
            </p>
          </div>
          <div className="p-5 rounded-lg bg-background-100 border border-background-200/60">
            <div className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-3">
              <i className="ri-links-line"></i>
            </div>
            <h3 className="font-semibold text-foreground-900 text-sm mb-1.5">Direct Access to Products</h3>
            <p className="text-xs text-foreground-600 leading-relaxed">
              Every item in the spreadsheet links directly to the product page, so once you find something you like, purchasing is just a click away with no extra steps or confusion.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}